import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component( {
    selector: 'ridango-selectable-block-wrapper',
    templateUrl: './selectable-block-wrapper.component.html'
} )
export class SelectableBlockWrapperComponent implements OnInit {
    @Input() selected = false;
    @Input() item;
    @Input() locale = null;
    @Input() disabled = false;
    @Input() itemImage = false;
    @Output() onItemSelected = new EventEmitter<any>();
    constructor() { }
    ngOnInit () { }
    itemSelected () {
        if ( !this.disabled ) {
            this.onItemSelected.emit( this.item );
        }
    }

    getItemTranslation () {
        if ( !this.item.translations ) {
            return this.item.name ? this.item.name : '';
        }
        return this.item.translations.find( t => {
            return t.lang === this.locale;
        } ) !== undefined ? this.item.translations.find( t => {
            return t.lang === this.locale;
        } ).translation : this.item.name ? this.item.name : '-';
    }
}
